/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function MedalIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="medal"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 13L13.176 15.382L15.804 15.764L13.902 17.618L14.351 20.236L12 19L9.649 20.236L10.098 17.618L8.196 15.764L10.824 15.382L12 13Z" data-tinysvg-shape="star" data-tinysvg-star="12 17 4 5 50 0 0" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.5 3.5C4.395 3.5 3.5 4.395 3.5 5.5L3.5 6.161C3.5 6.971 3.989 7.701 4.739 8.01L11.239 10.686C11.726 10.887 12.274 10.887 12.761 10.686L19.261 8.01C20.011 7.701 20.5 6.971 20.5 6.161L20.5 5.5C20.5 4.395 19.605 3.5 18.5 3.5L5.5 3.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8 3.5L8 9" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16 3.5L16 9" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
